<template>
	<div class="row logo-bar" :class="small?'layout-small':''">
		<div class="logo-bar-inner text-center" :class="small?'col-6':'col-12'">
			<img src="../../public/img/logo-dark_cut.png" class="img-fluid">
			<div class="subtitle">Flaschenmanagement</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "LogoBar",
		props: {
			small: Boolean
		}
	}
</script>

<style scoped>

</style>
